export const NOT_PACKED_STATUSES = [
    'READY',
    'PENDING',
    'PROCESSED',
    'RETRY_SHIP',
    'PACKED'
]